import { Field } from "typegraph";

class CreditType {
	@Field()
	public id: string;

	@Field()
	public name: string;
}

export class Credit {
	@Field()
	public id: string;

	@Field({entity: CreditType})
	public creditType: CreditType;

	@Field()
	public value: number;	
}







// WEBPACK FOOTER //
// ./src/panels/subscriptions/entities/Credit.ts